import React, { useEffect, useState } from "react";
import UserContext from "./UserContext";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices";

const UserContextProvider = ({ children }) => {
  const companyID = StorageService.getCompanyId()
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [masterData, setMasterData] = useState(null);
  const [genrateOtp, setGenrateOtp] = useState(false);
  const [isSidebar, setToggleSidebar] = useState(false);
  const [showAddAcountModal, setShowAddAcountModal] = useState(false);
  const [showCreateCompanyModal, setShowCreateCompanyModal] = useState(false);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [commonError, setCommonError] = useState("");
  const [userData, setUserData] = useState();
  const [userDetails, setUserDetails] = useState();
  const [allMenu, setAllMenu] = useState([]);
  const [globCompanyId, setGlobCompanyId] = useState("");
  const [lrPermissions, setLrPermissions] = useState([]);
  const [mastersChild, setMastersChild] = useState([]);
  const [settingChild, setSettingChild] = useState([]);
  const [reportChild, setReportChild] = useState([]);
  const [accountingChild, setAccountingChild] = useState([]);
  const [truckChild, setTruckChild] = useState([]);
  const [globTripDetails, setGlobTripDetails] = useState();
  const [bankDetails, setBankDetails] = useState("");
  const [modalZIndex, setModalZIndex] = useState("");
  const [isMaterialIndex, setIsMaterialIndex] = useState("");
  const [fromStationToUnit, setFromStationToUnit] = useState({});
  const [lrDetialsFrom, setLrDetialsFrom] = useState("");
  const [invoiceBillRaiseData, setInvoiceBillRaiseData] = useState({});
  const [sidebarActive, setSidebarActive] = useState();
  const [sideBarRoutingManage, setSidebarRoutingManage] = useState({});
  const [isDriverName, setIsDriverName] = useState('');
  const [connectionDetailsGlobal, setConnectionDetailsGlobal] = useState({});
  const [dispatchIndent, setDispatchIndent] = useState("");
  const [tripFilters, setTripFilters] = useState(0);
  const [permissionModal, setPermissionModal] = useState(false)
  const [userSettingPermission, setUserSettingPermission] = useState("")
  const [generalLedgerDate, setGeneralLedgerDate] = useState({});
  const [vehicleDeatils, setVehicleDetails] = useState({});

  const [masterDetailsList, setMasterDetailsList] = useState({
    list: [],
    details: {}
  })

  const [tripFilter, setTRipFilter] = useState({
    company_id: StorageService.getCompanyId(),
    consignor_id: "",
    supplier_id: "",
    driver_id: "",
    vehicle_ownership: 0,
    from_location: "",
    to_location: "",
    branch_id: "",
    start_date: "",
    end_date: "",
    limit: 25,
    offset: 1,
    search: "",
    trip_status: 0,
    responses: 0,
    vehicle_id: "",
  })

  const [generalExpensesIndex, setGeneralExpensesIndex] = useState(null)
  const [planFilter, setPlanFilter] = useState({
    company_id: StorageService.getCompanyId(),
    start_date: "",
    end_date: "",
    plan_status: 1,
    bid_status: 0,
    responses: 0,
    limit: 25,
    offset: 1,
    search: "",
    consignor_id: "",
    branch_id: "",
    from_location: "",
    to_location: "",
    vehicle_id: "",
  });

  const [lrModalToggleForEway, setLrModalToggleForEway] = useState(false);

  const [ewayBillInitialData, setEwayBillInitialData] = useState({});
  const [ewayBillLrData, setEwayBillLrData] = useState({});

  const [searchText, setSearchText] = useState("");
  const [dashboardFilterClear, setDashboardFilterClear] = useState(false);

  const [createDocument, setCreateDocument] = useState(false);

  const [invoiceTableToggle, setInvoiceTableToggle] = useState(true)
  const [invoiceFilters, setInvoiceFilters] = useState({
    from_location: {},
    to_location: {},
    pod_status: {},
    vehicle_id: {},
    vehicle_ownership: {},
    lr_date_range: {
      start_date: "",
      end_date: ""
    },
    dispatch_date_range: {
      start_date: "",
      end_date: ""
    },
    indent_date_range: {
      start_date: "",
      end_date: ""
    },
    pod_date_range: {
      start_date: "",
      end_date: ""
    },
    consignor_id: {},
    template_id: {},
    company_id: "",
    limit: 25,
    offset: 1,
    search: "",
    select_lr_ids: [],
    sort_field: "lr_number",
    sort_order: "asc"
  })

  const [subscriptionDetails, setSubscriptionDetails] = useState({})
  const [warningDetails, setWarningDetails] = useState({})
  const [showWarnning, setShowWarnning] = useState(false)
  const [showUpdateBtn, setShowUpdateBtn] = useState(false)
  const [showCompany, setShowCompany] = useState(false);
  const [vehicleDriverSupplierFirm, setVehicleDriverSupplierFirm] = useState({});

  useEffect(() => {
    setTRipFilter((pre) => ({ ...pre, company_id: companyID }))
    setPlanFilter((pre) => ({ ...pre, company_id: companyID }))
  }, [companyID])

  const [noAccessISOpen, setNoAccessISOpen] = useState(false)


  return (
    <UserContext.Provider
      value={{
        setDispatchIndent,
        dispatchIndent,
        setBankDetails,
        bankDetails,
        lrPermissions, setLrPermissions,
        mastersChild,
        setMastersChild,
        settingChild,
        setSettingChild,
        reportChild,
        setReportChild,
        accountingChild,
        setAccountingChild,
        setGlobCompanyId,
        globCompanyId,
        allMenu,
        setAllMenu,
        userDetails,
        setUserDetails,
        setUserData,
        userData,
        commonError,
        setCommonError,
        setCities,
        cities,
        states,
        setStates,
        masterData,
        setMasterData,
        genrateOtp,
        setGenrateOtp,
        isSidebar,
        setToggleSidebar,
        token,
        setToken,
        showAddAcountModal,
        setShowAddAcountModal,
        showCreateCompanyModal,
        setShowCreateCompanyModal,
        setGlobTripDetails: setGlobTripDetails,
        globTripDetails: globTripDetails,
        setModalZIndex,
        modalZIndex,
        setIsMaterialIndex,
        isMaterialIndex,
        setFromStationToUnit,
        fromStationToUnit,
        setLrDetialsFrom,
        lrDetialsFrom,
        invoiceBillRaiseData,
        setInvoiceBillRaiseData,
        setSidebarActive,
        sidebarActive,
        setSidebarRoutingManage,
        sideBarRoutingManage,
        setIsDriverName,
        isDriverName,
        setConnectionDetailsGlobal,
        connectionDetailsGlobal,
        setTripFilters, tripFilters,
        permissionModal, setPermissionModal, setUserSettingPermission, userSettingPermission,
        generalLedgerDate, setGeneralLedgerDate,
        setTRipFilter: setTRipFilter,
        tripFilter: tripFilter,
        generalExpensesIndex, setGeneralExpensesIndex,
        setPlanFilter,
        planFilter,
        ewayBillInitialData, setEwayBillInitialData,
        searchText,
        setSearchText,
        dashboardFilterClear, setDashboardFilterClear,
        createDocument, setCreateDocument,
        invoiceTableToggle, setInvoiceTableToggle,
        invoiceFilters, setInvoiceFilters,
        setSubscriptionDetails,
        subscriptionDetails,
        setWarningDetails, warningDetails,
        showWarnning, setShowWarnning,
        showUpdateBtn, setShowUpdateBtn,
        setVehicleDetails,
        vehicleDeatils,
        setShowCompany,
        showCompany,
        setTruckChild,
        truckChild,
        lrModalToggleForEway, setLrModalToggleForEway,
        ewayBillLrData, setEwayBillLrData,
        vehicleDriverSupplierFirm, setVehicleDriverSupplierFirm,
        setNoAccessISOpen, noAccessISOpen,
        masterDetailsList, setMasterDetailsList
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;